import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center display-2 my-8 font-weight-bold"
}
const _hoisted_2 = { class: "pa-8" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-8" }
const _hoisted_6 = { class: "my-8" }
const _hoisted_7 = { class: "mt-8" }
const _hoisted_8 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_SkillLogosComponent = _resolveComponent("SkillLogosComponent")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    elevation: "2",
    class: "px-4",
    variant: "tonal",
    border: "top",
    "border-color": "success"
  }, {
    default: _withCtx(() => [
      false
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, " Collaboration "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Advising and Talks", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_chip, {
              label: "",
              "x-large": "",
              class: "mr-2 mb-2"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("h3", { class: "font-weight-regular" }, "Team", -1)
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(_component_v_chip, {
              label: "",
              "x-large": "",
              class: "mr-2 mb-2"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("h3", { class: "font-weight-regular" }, "Product", -1)
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(_component_v_chip, {
              label: "",
              "x-large": "",
              class: "mr-2 mb-2"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("h3", { class: "font-weight-regular" }, "Architecture", -1)
              ])),
              _: 1,
              __: [2]
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Algorithms", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_chip, {
              label: "",
              "x-large": "",
              class: "mr-2 mb-2"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("h3", { class: "font-weight-regular" }, "National Level", -1)
              ])),
              _: 1,
              __: [4]
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Systems Architecture", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SkillLogosComponent)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}